import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function TestimonialFeatured() {
  const testimonials = [{
    quote: 'Armé 3 campañas completas en una tarde. Los prompts del Tomo de Copywriting me ahorran horas cada semana.',
    author: 'Martina G.',
    location: 'Buenos Aires',
    role: 'Freelancer Meta Ads',
    initial: 'M'
  }, {
    quote: 'El sistema de diagnóstico del Bono 6 por fin me explica qué cambiar cuando el ROAS cae. Vale cada peso.',
    author: 'Lucas P.',
    location: 'Rosario',
    role: 'Agencia Digital',
    initial: 'L'
  }, {
    quote: 'Mis campañas de B2B por fin convierten. El Tomo de Segmentación cambió todo.',
    author: 'Roberto M.',
    location: 'Córdoba',
    role: 'Media Buyer Senior',
    initial: 'R'
  }];
  const Stars = () => <div className="flex gap-1 text-yellow-400 mb-3 justify-center md:justify-start" data-id="element-313">
      {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-314" />)}
    </div>;
  return <FadeIn delay={0.2} data-id="element-315">
      <section className="py-12 px-4 max-w-4xl mx-auto" data-id="element-316">
        <div className="space-y-4" data-id="element-317">
          {testimonials.map((t, i) => <div key={i} className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-2xl p-6 md:p-8 relative overflow-hidden" data-id="element-318">
              <div className="flex flex-col md:flex-row gap-6 items-center md:items-start" data-id="element-319">
                <div className="flex-grow text-center md:text-left" data-id="element-320">
                  <Stars data-id="element-321" />
                  <p className="text-lg md:text-xl font-medium text-gray-200 leading-relaxed mb-4 italic" data-id="element-322">
                    "{t.quote}"
                  </p>
                  <div className="flex items-center justify-center md:justify-start gap-3" data-id="element-323">
                    <div className="w-10 h-10 bg-green-900 rounded-full flex items-center justify-center text-green-400 font-bold text-lg shrink-0" data-id="element-324">
                      {t.initial}
                    </div>
                    <div className="text-left" data-id="element-325">
                      <p className="font-bold text-white" data-id="element-326">{t.author}</p>
                      <p className="text-sm text-gray-400" data-id="element-327">
                        {t.location} · {t.role}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </section>
    </FadeIn>;
}